/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShareClaimAccessResponseData } from './ShareClaimAccessResponseData';
import {
    ShareClaimAccessResponseDataFromJSON,
    ShareClaimAccessResponseDataFromJSONTyped,
    ShareClaimAccessResponseDataToJSON,
    ShareClaimAccessResponseDataToJSONTyped,
} from './ShareClaimAccessResponseData';

/**
 * An access grant was created immediately for an existing user or company.
 * @export
 * @interface ShareClaimAccessResponse
 */
export interface ShareClaimAccessResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ShareClaimAccessResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShareClaimAccessResponse
     */
    kind: ShareClaimAccessResponseKindEnum;
    /**
     * Always false for this variant. Retained for convenience alongside `kind`.
     * @type {boolean}
     * @memberof ShareClaimAccessResponse
     */
    pending: boolean;
    /**
     * 
     * @type {ShareClaimAccessResponseData}
     * @memberof ShareClaimAccessResponse
     */
    data: ShareClaimAccessResponseData;
}


/**
 * @export
 */
export const ShareClaimAccessResponseKindEnum = {
    Access: 'access'
} as const;
export type ShareClaimAccessResponseKindEnum = typeof ShareClaimAccessResponseKindEnum[keyof typeof ShareClaimAccessResponseKindEnum];


/**
 * Check if a given object implements the ShareClaimAccessResponse interface.
 */
export function instanceOfShareClaimAccessResponse(value: object): value is ShareClaimAccessResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('pending' in value) || value['pending'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShareClaimAccessResponseFromJSON(json: any): ShareClaimAccessResponse {
    return ShareClaimAccessResponseFromJSONTyped(json, false);
}

export function ShareClaimAccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShareClaimAccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'kind': json['kind'],
        'pending': json['pending'],
        'data': ShareClaimAccessResponseDataFromJSON(json['data']),
    };
}

export function ShareClaimAccessResponseToJSON(json: any): ShareClaimAccessResponse {
    return ShareClaimAccessResponseToJSONTyped(json, false);
}

export function ShareClaimAccessResponseToJSONTyped(value?: ShareClaimAccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'kind': value['kind'],
        'pending': value['pending'],
        'data': ShareClaimAccessResponseDataToJSON(value['data']),
    };
}

